import { TUI_IS_MOBILE_RES } from '@taiga-ui/core';
import { TuiLetModule } from '@taiga-ui/cdk';
import { Store } from '@ngrx/store';
import { Component, inject } from '@angular/core';
import { AsyncPipe, NgIf, NgTemplateOutlet } from '@angular/common';

import { CountryFlagComponent } from '../country-flag';

import { InlineLabelComponent } from './inline-label';

import { appContextFeature, authFeature } from '@wo-mc/+state';
import {
  CapitalizePipe,
  CustomerNamePipe,
  IsFalsyPipe,
  LocalePipe,
  ServiceLocationNamePipe,
  SiteNamePipe,
  SupplierNamePipe,
} from '@iss/wo-common/pipes';

@Component({
  selector: 'wo-page-context-bar',
  templateUrl: './page-context-bar.component.html',
  styleUrls: [ './page-context-bar.component.scss' ],
  standalone: true,
  imports: [
    AsyncPipe,
    CapitalizePipe,
    CountryFlagComponent,
    CustomerNamePipe,
    InlineLabelComponent,
    IsFalsyPipe,
    LocalePipe,
    NgIf,
    NgTemplateOutlet,
    ServiceLocationNamePipe,
    SiteNamePipe,
    SupplierNamePipe,
    TuiLetModule,
  ],
})
export class PageContextBarComponent {
  private readonly store = inject(Store);
  public readonly isMobileRes$ = inject(TUI_IS_MOBILE_RES);
  public readonly hasContext$ = this.store.select(appContextFeature.selectHasContext);
  public readonly customerId$ = this.store.select(appContextFeature.selectCustomer);
  public readonly siteId$ = this.store.select(appContextFeature.selectSite);
  public readonly serviceLocationId$ = this.store.select(appContextFeature.selectServiceLocation);
  public readonly supplierId$ = this.store.select(appContextFeature.selectSupplier);
  public readonly hasMultipleRoles$ = this.store.select(authFeature.selectHasMultipleRoles);
  public readonly role$ = this.store.select(appContextFeature.selectRole);
  public readonly hasMultipleCountries$ = this.store.select(appContextFeature.selectHasMultipleCountries);
  public readonly country$ = this.store.select(appContextFeature.selectCountry);
}
